import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { CostDirection, PagedResponseCostDirection } from '../models/CostDirection';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class CostDirectionService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getCostDirections():Observable<PagedResponseCostDirection>{
    const data =  this.http.get<PagedResponseCostDirection>(this.APIURL+'/CostDirection' + '?PageNumber=1&PageSize=50');
    this.messageService.add('CostDirection Service: fetched shops');
    return data;
  }

  getCostDirection(id: number): Observable<CostDirection> {
        const CostDirection =this.http.get<CostDirection>(this.APIURL+'/CostDirection/' + id);
    this.messageService.add(`CostDirection Service: fetched CostDirection with id=${id}`);
    return CostDirection;
  }
}